
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      default: 'OK'
    }
  }
}
